export default function formatUf(data){

  return data.map(state => state.uf).join(', ');


}
